import { render, staticRenderFns } from "./CorporationSelector.vue?vue&type=template&id=b89329c4&scoped=true&"
import script from "./CorporationSelector.vue?vue&type=script&lang=js&"
export * from "./CorporationSelector.vue?vue&type=script&lang=js&"
import style0 from "./CorporationSelector.vue?vue&type=style&index=0&id=b89329c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89329c4",
  null
  
)

export default component.exports